module.exports = __webpack_public_path__ + "img/8L.8719399a.png";